const header =
    typeof navigator !== 'undefined'
        ? [
              navigator.platform,
              navigator.userAgent,
              navigator.appVersion,
              navigator.vendor,
              window.opera,
          ]
        : [];

const databrowser = [
    { name: 'Chrome', value: 'Chrome', version: 'Chrome' },
    { name: 'Firefox', value: 'Firefox', version: 'Firefox' },
    { name: 'Safari', value: 'Safari', version: 'Version' },
    { name: 'Internet Explorer', value: 'MSIE', version: 'MSIE' },
    { name: 'Mozilla', value: 'Mozilla', version: 'Mozilla' },
];

const matchItem = (string, data) => {
    let i;
    let j;
    let regex;
    let regexv;
    let match;
    let matches;
    let version;

    for (i = 0; i < data.length; i++) {
        regex = new RegExp(data[i].value, 'i');
        match = regex.test(string);
        if (match) {
            regexv = new RegExp(`${data[i].version}[- /:;]([\\d._]+)`, 'i');
            matches = string.match(regexv);
            version = '';
            if (matches) {
                if (matches[1]) {
                    matches = matches[1];
                }
            }
            if (matches) {
                matches = matches.split(/[._]+/);
                for (j = 0; j < matches.length; j++) {
                    if (j === 0) {
                        version += `${matches[j]}.`;
                    } else {
                        version += matches[j];
                    }
                }
            } else {
                version = '0';
            }
            return {
                name: data[i].name,
                version: parseFloat(version),
                originalVersion: version,
            };
        }
    }
    return { name: 'unknown', version: 0 };
};

/**
 * Return an object containing the infos about the browser
 * @returns {{name, version}} The name and version of the current browser
 */
export default function getBrowserInfo() {
    const agent = header.join(' ');
    return matchItem(agent, databrowser);
}
